export const PROFILE_CONFIG = {
  // Motor Impaired (Profile)
  s101: {
    features: {
      // Stop Animations
      s13: 1,
      // Tooltips
      s12: 1,
    },
  },
  // Blind (reader) (Profile)
  s102: {
    features: {
      // Reader
      s9: 1,
    },
  },
  // Color Blind (Profile)
  s103: {
    features: {
      // Smart Contrast
      s18: 1,
      // High Saturation
      s23: 2,
    },
  },
  // Dyslexia (Profile)
  s104: {
    features: {
      // Dyslexia Font
      s7: 1,
      // Stop Animation
      s13: 1,
    },
  },
  // Visually-impaired (Profile)
  s105: {
    features: {
      // Bigger Text
      s4: 1,
      // High Saturation
      s23: 2,
      // Stop Animations
      s13: 1,
      // Legible Font
      s7: 2,
      // Cursor
      s2: 1,
      // Tooltips
      s12: 1,
    },
  },
  // Cognitive & Learning (Profile)
  s106: {
    features: {
      // Smart Contrast
      s18: 1,
      // Bigger Text
      s4: 1,
      // Tooltips
      s12: 1,
      // Stop Animations
      s13: 1,
      // Reading Guide
      s2: 3,
    },
  },
  // Seizure & Epileptic (Profile)
  s107: {
    features: {
      // Stop Animations
      s13: 1,
      // Low Saturation
      s23: 1,
    },
  },
  // ADHD (Profile)
  s108: {
    features: {
      // Stop Animations
      s13: 1,
      // Reading Mask
      s2: 2,
      // Low Saturation
      s23: 1,
    },
  },
};
